import { atomWithKey as atom } from "./atomWithKey";
import { IUserResponse } from "../Types/Interface/IUser";

export const userDataAtom = atom<IUserResponse | null>({
  key: "userDataAtom",
  default: null,
});
